export default "__VITE_PUBLIC_ASSET__81e16274__"